import {
  enrich_sla_config_item_for_vm,
  fetch_sla_configs_for_vm,
  fetch_workflow_options_for_vm,
  get_sort_label,
} from './service_layer_agreement.collection_helpers';
import {
  build_normalized_sla_item,
  format_date_value,
  format_duration_value,
  parse_duration_input_value,
} from './service_layer_agreement.format_helpers';
import { normalize_workflow_option_value } from './service_layer_agreement.helpers';

export default {
  normalize_sla_item(item = {}) {
    const normalized_item = build_normalized_sla_item(item, this);
    return normalized_item;
  },
  normalize_workflow_option(item = {}, index = 0) {
    const normalized_option = normalize_workflow_option_value(item, index);
    return normalized_option;
  },
  format_date(date_value) {
    const formatted_value = format_date_value(date_value);
    return formatted_value;
  },
  format_duration(duration_value) {
    const formatted_value = format_duration_value(duration_value);
    return formatted_value;
  },
  parse_duration_input(duration_value) {
    const parsed_value = parse_duration_input_value(duration_value);
    return parsed_value;
  },
  async fetch_sla_configs() {
    await fetch_sla_configs_for_vm(this);
  },
  async fetch_workflow_options() {
    await fetch_workflow_options_for_vm(this);
  },
  async enrich_sla_config_item(item = {}) {
    const enriched_item = await enrich_sla_config_item_for_vm(item, this);
    return enriched_item;
  },
  toggle_filter_mode() {
    if (this.filter_mode === 'all') this.filter_mode = 'active';
    else if (this.filter_mode === 'active') this.filter_mode = 'inactive';
    else this.filter_mode = 'all';
  },
  cycle_sort_mode() {
    const order = ['updated_desc', 'updated_asc', 'name_asc', 'name_desc', 'created_asc'];
    const current_index = order.indexOf(this.sort_mode);
    this.sort_mode = order[(current_index >= 0 ? current_index + 1 : 0) % order.length];
  },
  sort_label() {
    const sort_label = get_sort_label(this.sort_mode);
    return sort_label;
  },
  set_page(page) {
    if (page < 1 || page > this.total_pages) return;
    this.current_page = page;
  },
};
